import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading',
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  items = new Array(5);
}
